import { useEffect, useState } from 'react';
import { validateRequired, ErrorMessage, validateNumeric } from '../../utlis/function.js';
import CommonLoader from '../common/CommonLoader.jsx';

const TimeDurationModal = ({
  onClose,
  title = "Duration",
  description = "Set pricing for ad spots across different subscription plans.",
  onSave,
  initialData = {},
  isLoading,
  durationType = 15 // 15 or 30
}) => {
  const [formData, setFormData] = useState({
    price1Month: '',
    price6Month: '',
    price12Month: ''
  });

  const [dayPartStatus, setDayPartStatus] = useState(false);
  
  const [daypartData, setDaypartData] = useState({
    daypartOpen10AM: '',
    dp10AmLimit: '',
    daypart10AMto4PM: '',
    dp10_4Limit: '',
    daypart4PMClose: '',
    dp4PmLimit: '',
    daypartWeekendsOnly: '',
    dpWeekendAmLimit: ''
  });

  const [errors, setErrors] = useState({});
console.log("initial data ", initialData)
  useEffect(() => {
    // Set pricing data
    setFormData({
      price1Month: initialData.price1Month || '',
      price6Month: initialData.price6Month || '',
      price12Month: initialData.price12Month || ''
    });

    // Set daypart status and data
    setDayPartStatus(initialData.dayPartStatus || false);
    setDaypartData({
      daypartOpen10AM: initialData.daypartOpen10AM || '',
      dp10AmLimit: initialData.dp10AmLimit || '',
      daypart10AMto4PM: initialData.daypart10AMto4PM || '',
      dp10_4Limit: initialData.dp10_4Limit || '',
      daypart4PMClose: initialData.daypart4PMClose || '',
      dp4PmLimit: initialData.dp4PmLimit || '',
      daypartWeekendsOnly: initialData.daypartWeekendsOnly || '',
      dpWeekendAmLimit: initialData.dpWeekendAmLimit || ''
    });
  }, [initialData]);

const handleInputChange = (field, value) => {
  let cleaned = value.replace(/[^0-9.]/g, '');

  const dotCount = (cleaned.match(/\./g) || []).length;
  if (dotCount > 1) return;

  if (/^0[0-9]/.test(cleaned)) return;

  setFormData(prev => ({ ...prev, [field]: cleaned }));

  if (errors[field]) {
    setErrors(prev => ({ ...prev, [field]: '' }));
  }
};


  const handleDaypartInputChange = (field, value) => {
    const numericValue = value.replace(/[^0-9]/g, '');
    setDaypartData(prev => ({ ...prev, [field]: numericValue }));

    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  const validateFields = () => {
    const newErrors = {};

    // Validate pricing fields
    if (!validateRequired(formData.price1Month)) {
      newErrors.price1Month = '1 Month price is required';
    }

    if (!validateRequired(formData.price6Month)) {
      newErrors.price6Month = '6 Month price is required';
    }

    if (!validateRequired(formData.price12Month)) {
      newErrors.price12Month = '12 Month price is required';
    }

    // Validate daypart fields if enabled
    if (dayPartStatus) {
      if (!validateRequired(daypartData.daypartOpen10AM)) {
        newErrors.daypartOpen10AM = 'Open 10:00AM price is required';
      }else if(daypartData.daypartOpen10AM <= 0){
           newErrors.daypartOpen10AM = 'must be greater than 0';
      }
      if (!validateRequired(daypartData.dp10AmLimit)) {
        newErrors.dp10AmLimit = 'Open 10:00AM limit is required';
      }else if(daypartData.dp10AmLimit <= 0){
           newErrors.dp10AmLimit = 'must be greater than 0';
      }

      if (!validateRequired(daypartData.daypart10AMto4PM)) {
        newErrors.daypart10AMto4PM = '10:00AM - 04:00PM price is required';
      }else if(daypartData.daypart10AMto4PM <= 0){
           newErrors.daypart10AMto4PM = 'must be greater than 0';
      }
      if (!validateRequired(daypartData.dp10_4Limit)) {
        newErrors.dp10_4Limit = '10:00AM - 04:00PM limit is required';
      }else if(daypartData.dp10_4Limit <= 0){
           newErrors.dp10_4Limit = 'must be greater than 0';
      }

      if (!validateRequired(daypartData.daypart4PMClose)) {
        newErrors.daypart4PMClose = '04:00PM Close price is required';
      }else if(daypartData.daypart4PMClose <= 0){
           newErrors.daypart4PMClose = 'must be greater than 0';
      }
      if (!validateRequired(daypartData.dp4PmLimit)) {
        newErrors.dp4PmLimit = '04:00PM Close limit is required';
      }else if(daypartData.dp4PmLimit <= 0){
           newErrors.dp4PmLimit = 'must be greater than 0';
      }

      if (!validateRequired(daypartData.daypartWeekendsOnly)) {
        newErrors.daypartWeekendsOnly = 'Weekends Only price is required';
      }else if(daypartData.daypartWeekendsOnly <= 0){
           newErrors.daypartWeekendsOnly = 'must be greater than 0';
      }
      if (!validateRequired(daypartData.dpWeekendAmLimit)) {
        newErrors.dpWeekendAmLimit = 'Weekends Only limit is required';
      }else if(daypartData.dpWeekendAmLimit <= 0){
           newErrors.dpWeekendAmLimit = 'must be greater than 0';
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validateFields()) return;
    
    const saveData = {
      ...formData,
      dayPartStatus,
      ...(dayPartStatus && {
        daypartOpen10AM: daypartData.daypartOpen10AM,
        dp10AmLimit: daypartData.dp10AmLimit,
        daypart10AMto4PM: daypartData.daypart10AMto4PM,
        dp10_4Limit: daypartData.dp10_4Limit,
        daypart4PMClose: daypartData.daypart4PMClose,
        dp4PmLimit: daypartData.dp4PmLimit,
        daypartWeekendsOnly: daypartData.daypartWeekendsOnly,
        dpWeekendAmLimit: daypartData.dpWeekendAmLimit
      })
    };
    
    await onSave(saveData, {closeModal: false});
    onClose()
  };
const hasDaypartData = () => {
  return Object.values(daypartData).some(
    (val) => val !== "" && val !== null && val !== undefined
  );
};

const handleToggleDaypart = async () => {
  const newStatus = !dayPartStatus;

  // 1️⃣ Update UI immediately
  setDayPartStatus(newStatus);

    setDaypartData({
      daypartOpen10AM: initialData.daypartOpen10AM || '',
      dp10AmLimit: initialData.dp10AmLimit || '',
      daypart10AMto4PM: initialData.daypart10AMto4PM || '',
      dp10_4Limit: initialData.dp10_4Limit || '',
      daypart4PMClose: initialData.daypart4PMClose || '',
      dp4PmLimit: initialData.dp4PmLimit || '',
      daypartWeekendsOnly: initialData.daypartWeekendsOnly || '',
      dpWeekendAmLimit: initialData.dpWeekendAmLimit || ''
    });
  // 2️⃣ If turning OFF → clear data + CALL API
  // if (!newStatus) {
  //   setDaypartData({
  //     daypartOpen10AM: "",
  //     dp10AmLimit: "",
  //     daypart10AMto4PM: "",
  //     dp10_4Limit: "",
  //     daypart4PMClose: "",
  //     dp4PmLimit: "",
  //     daypartWeekendsOnly: "",
  //     dpWeekendAmLimit: "",
  //   });

  //   try {
  //     await onSave({
  //       ...formData,
  //       dayPartStatus: false, // ✅ explicit
  //     });
  //   } catch (err) {
  //     console.error("Failed to disable daypart", err);
  //   }

  //   return; 
  // }

  // 3️⃣ If turning ON → call API ONLY if data exists
  // if (hasDaypartData()) {
  //   try {
  //     await onSave({
  //       ...formData,
  //       dayPartStatus: true,
  //       ...daypartData,
  //     });
  //   } catch (err) {
  //     console.error("Failed to enable daypart", err);
  //   }
  // }
};



  return (
    <div className="fixed inset-0 bg-[#000000b5] flex items-center justify-center z-50">
      <div className="bg-white rounded-[20px] max-w-[624px] w-full mx-4 relative  shadow-[0_4px_31.9px_11px_rgba(255,255,255,0.25)] animate-fade-in">
        {isLoading && <CommonLoader fullScreen />}

        <div className="p-8">
          <div className='max-h-[80vh] overflow-y-auto'>
          {/* Title */}
          <h2 className="text-[28px] font-semibold text-black mb-2">{title}</h2>

          {/* Description */}
          <p className="text-[16px] text-[#666666] mb-6">{description}</p>
          <div className="grid md:grid-cols-2 grid-cols-1 gap-3">
            {/* 1 Month */}
            <div className="mb-5">
              <label className="block text-sm font-medium text-black mb-2">
                1 Month
              </label>
              <input
                type="number"
                maxLength={10}
                placeholder="Enter Amount"
                value={formData.price1Month}
                onChange={(e) =>
                  handleInputChange("price1Month", e.target.value)
                }
                className={`w-full h-[48px] px-4 rounded-full border focus:outline-none transition-colors ${
                  errors.price1Month ? "border-red-500" : "border-[#DADADA]"
                }`}
              />
              <ErrorMessage message={errors.price1Month} />
            </div>

            {/* 6 Month */}
            <div className="mb-5">
              <label className="block text-sm font-medium text-black mb-2">
                6 Month
              </label>
              <input
                type="text"
                maxLength={10}
                placeholder="Enter Amount"
                value={formData.price6Month}
                onChange={(e) =>
                  handleInputChange("price6Month", e.target.value)
                }
                className={`w-full h-[48px] px-4 rounded-full border focus:outline-none transition-colors ${
                  errors.price6Month ? "border-red-500" : "border-[#DADADA]"
                }`}
              />
              <ErrorMessage message={errors.price6Month} />
            </div>

            {/* 12 Month */}
            <div className="mb-8">
              <label className="block text-sm font-medium text-black mb-2">
                12 Month
              </label>
              <input
                type="text"
                placeholder="Enter Amount"
                maxLength={10}
                value={formData.price12Month}
                onChange={(e) =>
                  handleInputChange("price12Month", e.target.value)
                }
                className={`w-full h-[48px] px-4 rounded-full border focus:outline-none transition-colors ${
                  errors.price12Month ? "border-red-500" : "border-[#DADADA]"
                }`}
              />
              <ErrorMessage message={errors.price12Month} />
            </div>
          </div>

          {/* Daypart Section - Only show for 30sec */}
          {durationType === 30 && (
            <div className="mb-8">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-xl font-semibold text-black">Daypart</h3>
                <button
                  onClick={ handleToggleDaypart}
                  className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors ${
                    dayPartStatus ? "bg-primary" : "bg-gray-300"
                  }`}
                >
                  <span
                    className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                      dayPartStatus ? "translate-x-5" : "translate-x-0.5"
                    }`}
                  />
                </button>
              </div>

              <p className="text-[14px] text-[#666666] mb-4">
                Adjust pricing based on time-of-day and high-traffic viewing
                windows.
              </p>

              {dayPartStatus && (
                <div className="space-y-4">
                  {/* Open 10:00AM */}
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-black mb-2">
                        Open 10:00AM
                      </label>
                      <input
                        type="text"
                        placeholder="Enter discount %"
                        value={daypartData.daypartOpen10AM}
                        maxLength={10}
                        onChange={(e) =>
                          handleDaypartInputChange(
                            "daypartOpen10AM",
                            e.target.value
                          )
                        }
                        className={`w-full h-[48px] px-4 rounded-full border focus:outline-none transition-colors ${
                          errors.daypartOpen10AM
                            ? "border-red-500"
                            : "border-[#DADADA]"
                        }`}
                      />
                      <ErrorMessage message={errors.daypartOpen10AM} />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-black mb-2">
                        Ads Limit
                      </label>
                      <input
                        type="text"
                        placeholder="Enter Limit"
                        value={daypartData.dp10AmLimit}
                        maxLength={10}
                        onChange={(e) =>
                          handleDaypartInputChange(
                            "dp10AmLimit",
                            e.target.value
                          )
                        }
                        className={`w-full h-[48px] px-4 rounded-full border focus:outline-none transition-colors ${
                          errors.dp10AmLimit
                            ? "border-red-500"
                            : "border-[#DADADA]"
                        }`}
                      />
                      <ErrorMessage message={errors.dp10AmLimit} />
                    </div>
                  </div>

                  {/* 10:00AM - 04:00PM */}
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-black mb-2">
                        10:00AM - 04:00PM
                      </label>
                      <input
                        type="text"
                        placeholder="Enter discount %"
                        maxLength={30}
                        value={daypartData.daypart10AMto4PM}
                        onChange={(e) =>
                          handleDaypartInputChange(
                            "daypart10AMto4PM",
                            e.target.value
                          )
                        }
                        className={`w-full h-[48px] px-4 rounded-full border focus:outline-none transition-colors ${
                          errors.daypart10AMto4PM
                            ? "border-red-500"
                            : "border-[#DADADA]"
                        }`}
                      />
                      <ErrorMessage message={errors.daypart10AMto4PM} />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-black mb-2">
                        Ads Limit
                      </label>
                      <input
                        type="text"
                        placeholder="Enter Limit"
                        maxLength={30}
                        value={daypartData.dp10_4Limit}
                        onChange={(e) =>
                          handleDaypartInputChange(
                            "dp10_4Limit",
                            e.target.value
                          )
                        }
                        className={`w-full h-[48px] px-4 rounded-full border focus:outline-none transition-colors ${
                          errors.dp10_4Limit
                            ? "border-red-500"
                            : "border-[#DADADA]"
                        }`}
                      />
                      <ErrorMessage message={errors.dp10_4Limit} />
                    </div>
                  </div>

                  {/* 04:00PM Close */}
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-black mb-2">
                        04:00PM Close
                      </label>
                      <input
                        type="text"
                        placeholder="Enter discount %"
                        maxLength={30}
                        value={daypartData.daypart4PMClose}
                        onChange={(e) =>
                          handleDaypartInputChange(
                            "daypart4PMClose",
                            e.target.value
                          )
                        }
                        className={`w-full h-[48px] px-4 rounded-full border focus:outline-none transition-colors border-[#DADADA]tion-colors ${
                          errors.daypart4PMClose
                            ? "border-red-500"
                            : "border-[#DADADA]"
                        }`}
                      />
                      <ErrorMessage message={errors.daypart4PMClose} />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-black mb-2">
                        Ads Limit
                      </label>
                      <input
                        type="text"
                        placeholder="Enter Limit"
                        maxLength={30}
                        value={daypartData.dp4PmLimit}
                        onChange={(e) =>
                          handleDaypartInputChange("dp4PmLimit", e.target.value)
                        }
                        className={`w-full h-[48px] px-4 rounded-full border focus:outline-none transition-colors border-[#DADADA] ${
                          errors.dp4PmLimit
                            ? "border-red-500"
                            : "border-[#DADADA]"
                        }`}
                      />
                      <ErrorMessage message={errors.dp4PmLimit} />
                    </div>
                  </div>

                  {/* Weekends Only */}
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-black mb-2">
                        Weekends Only
                      </label>
                      <input
                        type="text"
                        placeholder="Enter discount %"
                        maxLength={30}
                        value={daypartData.daypartWeekendsOnly}
                        onChange={(e) =>
                          handleDaypartInputChange(
                            "daypartWeekendsOnly",
                            e.target.value
                          )
                        }
                        className={`w-full h-[48px] px-4 rounded-full border focus:outline-none transition-colors border-[#DADADA]tion-colors ${
                          errors.daypartWeekendsOnly
                            ? "border-red-500"
                            : "border-[#DADADA]"
                        }`}
                      />
                      <ErrorMessage message={errors.daypartWeekendsOnly} />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-black mb-2">
                        Ads Limit
                      </label>
                      <input
                        type="text"
                        placeholder="Enter Limit"
                        maxLength={30}
                        value={daypartData.dpWeekendAmLimit}
                        onChange={(e) =>
                          handleDaypartInputChange(
                            "dpWeekendAmLimit",
                            e.target.value
                          )
                        }
                        className={`w-full h-[48px] px-4 rounded-full border focus:outline-none transition-colors border-[#DADADA] ${
                          errors.dpWeekendAmLimit
                            ? "border-red-500"
                            : "border-[#DADADA]"
                        }`}
                      />
                      <ErrorMessage message={errors.dpWeekendAmLimit} />
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
          </div>

          {/* Buttons */}
          <div className="flex gap-4">
            <button
              onClick={onClose}
              className="flex-1 h-[52px] rounded-full border border-[#06323A] text-[#06323A] font-medium hover:bg-gray-50"
            >
              Cancel
            </button>

            <button
              onClick={handleSave}
              className="flex-1 h-[52px] rounded-full bg-[#0A3A44] text-white font-medium hover:opacity-90"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimeDurationModal;

